<template>
  <div id="matrix-dtl-modal" class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal_sty">
      <div id="modal-moving">
        <div id="title-area">
          <h2 v-if="isNew">マトリクスデータ設定</h2>
          <h2 v-else>マトリクスデータ参照</h2>
        </div>
      </div>
      <div id="upper_block">
        <ul>
          <li>
            <span class="label">内部キー</span>
            <span class="dt_sty" v-if="isNew">{{ index }}</span>
            <span class="dt_sty" v-else>{{ refIdx }}</span>
          </li>
          <li>
            <span class="label">データ種別</span>
            <span class="dt_sty">{{ typeStr }}</span>
          </li>
          <li v-if="isNew">
            <span class="label">カラム幅</span>
            <select v-model="colWid">
              <option :value="100">100</option>
              <option :value="120">120</option>
            </select>
          </li>
        </ul>
      </div>
      <div class="data-area">
        <div id="mat_tbl"></div>
      </div>
      <div id="button_area">
        <button type="button" class="main_btn" @click="onEntry" v-if="isNew">登録</button>
        <button type="button" class="main_btn" @click="onEntry" v-else>更新</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import {API_URL} from '../../constants/App'
import {MATRIX_TYPE} from '../../constants/Type'
export default {
  name: 'MatrixDtlModal',
  props: {
    /** 内部キー(新規) */
    index: Number,
    /** データ種別(新規) */
    type: Number,
    cellCount: String,
    rowCount: String,
    isNew: Boolean
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** カラム幅 */
      colWid: 100,
      /** 内部キー(参照) */
      refIdx: null,
      /** データ種別(参照) */
      refType: null,
      matrixArr: []
    }
  },
  computed: {
    /** データ種別文字列 */
    typeStr: function () {
      if (this.type) {
        let typeObj = Object.values(MATRIX_TYPE).find(d => { if (d.code === this.type) return d })
        return typeObj.label
      }
      if (this.refType) {
        let typeObj = Object.values(MATRIX_TYPE).find(d => { if (d.code === this.refType) return d })
        return typeObj.label
      }
    }
  },
  watch: {
    colWid: function () {
      if (this.matrixArr.length > 0) {
        this.showDataTable(this.matrixArr)
      } else {
        this.createNewTable()
      }
    }
  },
  methods: {
    /** モーダル開閉 */
    showModal: function () {
      this.modalShown = true
    },
    /** 送信 */
    onEntry: function () {
      this.matrixArr = []
      let MatrixObj = function (index, type, matrixX, matrixY, matrixVal) {
        this.matrixIndex = index
        this.matrixType = type
        this.matrixMaxX = matrixX
        this.matrixMaxY = matrixY
        this.matrixValue = matrixVal
      }
      let tb = document.getElementById('mat_tbl').firstChild
      // trタグ全取得
      let data = tb.getElementsByTagName('tr')
      for (let i = 1; i < data.length; i++) {
        // trタグ一行をrowに代入
        let row = data[i]
        // 1行のtrタグのなかのtdタグを取得
        let cells = row.getElementsByTagName('td')
        for (let j = 1; j < cells.length; j++) {
          // X行最大値
          let x = data[0].getElementsByTagName('td')[j].getElementsByTagName('input')[0].value
          // Y行最大値
          let y = data[i].getElementsByTagName('td')[0].getElementsByTagName('input')[0].value
          // 値
          let val = cells[j].getElementsByTagName('input')[0].value
          if (this.isNew) {
            this.matrixArr.push(new MatrixObj(this.index, this.type, parseInt(x), parseInt(y), val))
          } else {
            this.matrixArr.push(new MatrixObj(this.refIdx, this.refType, parseInt(x), parseInt(y), val))
          }
        }
      }
      this.modalShown = false
    },
    /** キャンセル */
    onCancel: function () {
      this.matrixArr = []
      this.modalShown = false
    },
    /** 新規データテーブル作成 */
    createNewTable: function () {
      // tableタグ削除
      if (document.getElementsByTagName('table').length > 0) {
        let elem = document.getElementById('mat_tbl')// Element型
        while (elem.firstChild) elem.removeChild(elem.firstChild)
      }
      if (this.matrixArr.length > 0) {
        this.showDataTable(this.matrixArr)
      } else {
        let rows = []
        // tableタグ生成
        let tb = document.createElement('table')
        // カラム数に合わせてテーブルの幅を設定
        let tbWid = parseInt(this.cellCount) * this.colWid + 'px'
        tb.style.width = tbWid
        // #title-area,#upper_block,#button_area要素にも同じ幅を設定
        let titleEl = document.getElementById('title-area')
        titleEl.style.width = tbWid
        let upperEl = document.getElementById('upper_block')
        upperEl.style.width = tbWid
        let btnEl = document.getElementById('button_area')
        btnEl.style.width = tbWid
        for (let i = 0; i < parseInt(this.rowCount); i++) {
          // 行を挿入
          rows.push(tb.insertRow(-1))
          for (let j = 0; j < parseInt(this.cellCount); j++) {
            // 列を挿入
            let cell = rows[i].insertCell(-1)
            // tdタグにtext-alignを設定
            cell.style.textAlign = 'center'
            // inputタグ生成
            let inp = document.createElement('input')
            // inputタグに幅を設定
            inp.style.width = '55%'
            // tdタグに追加
            cell.appendChild(inp)
            // ボーダー設定
            cell.style.border = '1px solid #ddd'
            // 背景色の設定
            if (i === 0 || j === 0) {
              cell.style.backgroundColor = '#eee'
            } else {
              cell.style.backgroundColor = '#fff'
            }
          }
        }
        this.removeInput(tb)
        document.getElementById('mat_tbl').appendChild(tb)
      }
    },
    /** マトリクス詳細データ取得 */
    getTable: function (index) {
      axios.get(API_URL.MASTER + '/get-matrix-dtl/' + index
      ).then(response => {
        let matDtlList = response.data.data
        this.showDataTable(matDtlList)
        console.log(matDtlList)
        this.refIdx = matDtlList[0].matrixIndex
        this.refType = matDtlList[0].matrixType
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** データテーブル表示 */
    showDataTable: function (matDtlList) {
      // tableタグ削除
      if (document.getElementsByTagName('table').length > 0) {
        let elem = document.getElementById('mat_tbl')// Element型
        while (elem.firstChild) elem.removeChild(elem.firstChild)
      }
      // 行数取得
      let rowList = matDtlList.filter((obj, index, array) => {
        return (array.findIndex(function (r) {
          return obj.matrixMaxY === r.matrixMaxY
        }) === index)
      })
      // 列数取得
      let cellList = matDtlList.filter((obj, index, array) => {
        return (array.findIndex(function (c) {
          return obj.matrixMaxX === c.matrixMaxX
        }) === index)
      })
      // 全データを列数ごとに分割してリストにつめる
      let slice = matDtlList.reduce((table, item) => {
        let last = table[table.length - 1]
        if (last.length === cellList.length) {
          table.push([item])
          return table
        }
        last.push(item)
        return table
      }, [[]])
      this.createTbl(rowList, cellList)
      let tbl = document.getElementById('mat_tbl').firstChild
      // trタグ全取得
      let trLst = tbl.getElementsByTagName('tr')
      for (let i = 1; i < trLst.length; i++) {
        // trタグ1行をrowに代入
        let row = trLst[i]
        // 1行のtrタグのなかのtdタグを取得
        let cells = row.getElementsByTagName('td')
        for (let j = 1; j < cells.length; j++) {
          // データ追加
          cells[j].getElementsByTagName('input')[0].value = slice[i - 1][j - 1].matrixValue
        }
      }
      this.showModal()
    },
    createTbl: function (rowList, cellList) {
      let rows = []
      // tableタグ生成
      let tb = document.createElement('table')
      // カラム数に合わせてテーブルの幅を設定
      let tbWid = (cellList.length + 1) * this.colWid + 'px'
      tb.style.width = tbWid
      // #title-area,#upper_block,#button_area要素にも同じ幅を設定
      let titleEl = document.getElementById('title-area')
      titleEl.style.width = tbWid
      let upperEl = document.getElementById('upper_block')
      upperEl.style.width = tbWid
      let btnEl = document.getElementById('button_area')
      btnEl.style.width = tbWid
      for (let i = 0; i <= rowList.length; i++) {
        // trタグを挿入
        rows.push(tb.insertRow(-1))
        for (let j = 0; j <= cellList.length; j++) {
          // tdタグを挿入
          let cell = rows[i].insertCell(-1)
          // tdタグにtext-alignを設定
          cell.style.textAlign = 'center'
          // inputタグ生成
          let inp = document.createElement('input')
          // X軸カラム名をセット
          if (i === 0 && j > 0) {
            inp.setAttribute('value', cellList[j - 1].matrixMaxX)
          }
          // Y軸カラム名をセット
          if (i > 0 && j === 0) {
            inp.setAttribute('value', rowList[i - 1].matrixMaxY)
          }
          // inputタグに幅を設定
          inp.style.width = '65%'
          // tdタグに追加
          cell.appendChild(inp)
          // ボーダー設定
          cell.style.border = '1px solid #ddd'
          // 背景色の設定
          if (i === 0 || j === 0) {
            cell.style.backgroundColor = '#eee'
          } else {
            cell.style.backgroundColor = '#fff'
          }
        }
      }
      this.removeInput(tb)
      document.getElementById('mat_tbl').appendChild(tb)
    },
    /** 不要なinput削除 */
    removeInput: function (tb) {
      // テーブル最上部左端のinputタグを削除
      if (tb.getElementsByTagName('td')[0]) {
        let firstTd = tb.getElementsByTagName('td')[0]
        while (firstTd.firstChild) firstTd.removeChild(firstTd.firstChild)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.modal_sty{
  background-color: white;
  max-height: 80%;
  max-width: 90%;
  padding: 10px;
  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  overflow: auto;
  #title-area{
    border-bottom: 2px solid #ff4500;
    padding: 10px;
    position: relative;
    h2 {
      // 中央寄せ
      display: inline-flex;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      justify-content: center;
    }
  }
  padding: 20px;
  #upper_block {
    margin-top: 10px;
    li{
      margin-bottom: 20px;
      .label{
        min-width: 95px;
        display: inline-block;
        font-weight: bold;
      }
      .dt_sty{
        display: inline-block;
      }
    }
  }
  #mat_tbl {
    display: inline-flex;
  }
  #button_area{
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/master/MatrixDtlModal.vue